module.exports = __webpack_public_path__ + "img/icon_timesheet_hover.db733ebe.png";